import { showNotification } from '@/helper/helper';
import axios from 'axios';

const url = process.env.VUE_APP_URL;
delete axios.defaults.headers.common['Authorization'];

export const getMyVacancies = async (code, page = null, params = null) => {
    return await axios.get(
            url + '/doc/journal/applicant/?journal_code=' 
            + code 
            + (page ? '&page=' + page : '')
            + (params ?? '')
        , {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const makeResponse = async (vacancyId, userId, needToken = false) => {
    const response = {
        journal: {
            abc_code: 2451,
            vacancy_id: vacancyId,
            user_id: userId ?? undefined,
        },
        indicator: []
    };

    const params = {};
    if (needToken) params.headers = {
        'Authorization': 'Token ' + localStorage.getItem('token')
    }

    return await axios.post(url + '/doc/journal/applicant/', response, params)
        .catch(e => showNotification('error', e.response));
};

export const makeResponseByHr = async (vacancyId, userId) => {
    const data = {
        user_ids: [userId],
        vacancy_id: vacancyId
    };

    return await axios.post(url + '/doc/journal/applicant/direct/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const cancelResponse = async (applicatnId) => {
    return await axios.post(url + '/doc/journal/status/', 
        {
            applicant_id: applicatnId,
            status: 'cancel',
            comment: ''
        }, 
        {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        }
    ).catch(e => showNotification('error', e.response));
};

export const updateVacancy = async (data) => {
    return await axios.patch(url + '/doc/journal/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getStageUsers = async (vacancyId, stage, page, stageNumber) => {
    const path = url + '/doc/journal/vacancy/applicant/' + vacancyId 
        + '/?stage=' + stage  
        + (page ? ('&page=' + page) : '')  
        + ('&outer_stage=' + stageNumber);

    return await axios.get(path, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getRefusalVariants = async (stage) => {
    return await axios.get(url + '/dict/element/?stage=' + stage + '&dict_code=' + 10001, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const changeUserStage = async (data) => {
    return await axios.post(url + '/doc/journal/status/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const saveUserStageForm = async (userId, data) => {
    return await axios.post(url + '/doc/journal/vacancy/committee/' + userId + '/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getUserStageForm = async (userId, code1, code2, applicatnId) => {
    const path = url + '/doc/journal/vacancy/committee/' + userId 
        + '/?journal_code=' + code1 + (code2 ? (',' + code2) : '') 
        + '&applicant_id=' + applicatnId;

    return await axios.get(path, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const updateUserStageForm = async (userId, data) => {
    return await axios.patch(url + '/doc/journal/vacancy/committee/' + userId + '/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const sendStageDocument = async (data) => {
    return await axios.post(url + '/doc/journal/vacancy/applicant/detail/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const downloadStageFile = async (stage, userId, applicantId) => {
    const path = url + '/doc/journal/' + stage 
        + '/?user_id=' + userId 
        + '&applicant_id=' + applicantId;

    return await axios.get(path, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        },
        responseType: 'blob'
    }).catch(e => showNotification('error', e.response));
};

export const publishVacancy = async (vacancyId) => {
    return await axios.patch(url + '/doc/journal/vacancy/' + vacancyId + '/', null, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const sendToCommission = async (data) => {
    return await axios.post(url + '/send-applicant/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const sendLongList = async (data) => {
    return await axios.post(url + '/send-long-list/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const saveTestDocuments = async (data) => {
    return await axios.post(url + '/doc/journal/vacancy/applicant/application/', 
        data, 
        {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        }
    ).catch(e => showNotification('error', e.response));
};

export const getTestDocuments = async (vacancyId, stage) => {
    const path = url + '/doc/journal/vacancy/applicant/application/?vacancy_id=' 
        + vacancyId + '&outer_stage=' + stage;

    return await axios.get(path, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => console.error(e));
};

export const sendTest = async (data) => {
    return await axios.post(url + '/doc/journal/vacancy/applicant/sentresult/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const sendToRevision = async (data) => {
    return await axios.post(url + '/send-revision/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const vacancyNextStage = async (data) => {
    return await axios.post(url + '/doc/journal/vacancy/next-stage/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const vacancyCancel = async (data) => {
    return await axios.post(url + '/doc/journal/vacancy/cancel-extension/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getStageInfo = async (name, id, stageNumber) => {
    return await axios.get(url + '/doc/' + name + '/' + id + '/' + '?outer_stage=' + stageNumber, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const uploadLongExcel = async (data) => {
    return await axios.post(url + '/doc/journal/long/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getStageKanban = async (id, stage) => {
    return await axios.get(url + '/doc/journal/vacancy/applicant/canbandesk/' + id + '/?outer_stage=' + stage, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const saveExpComments = async (data) => {
    return await axios.post(url + '/save-comments-long/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getVacancyStatuses = async () => {
    return await axios.get(url + '/doc/indicator/parameter/status/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getManagers = async () => {
    return await axios.get(url + '/user/all/?group=HR_COMMANDER,HR CC', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getVacanciesByCity = async () => {
    return await axios.get(url + '/doc/journal/vacancy/count-by-city/')
        .catch(e => showNotification('error', e.response));
};

export const getLastVacancies = async () => {
    return await axios.get(url + '/doc/journal/vacancy/dzo/')
        .catch(e => showNotification('error', e.response));
};

export const downloadVacancyMetrixReport = async (params = null) => {
  const path =
    url +
    "/doc/journal/vacancy/metrix_report/" +
    (params ?? "");

  return await axios.get(path, {
    headers: {
      Authorization: "Token " + localStorage.getItem("token"),
    },
    responseType: "blob",
  }).catch((e) => showNotification("error", e.response));
};
